module.exports = __webpack_public_path__ + "img/icon_blocked.3512cb46.svg";